const TABS = {
  DIGITIZE: [
    {
      displayName: 'In Store Order',
      name: 'inStoreOrder',
      productsList: [
        'in_store_order_local_drop_off',
        'in_store_order_recycle',
        'in_store',
        'in_store_order_return_shipping',
      ],
    },
    {
      displayName: 'Home Ship Kit',
      name: 'homeShipKit',
      productsList: [
        'easy_home_ship_kit',
        'home_ship_kit_recycle',
      ],
    },
    {
      displayName: 'Local Pick Up',
      name: 'localPickUp',
      productsList: [
        'local_pickup',
        'local_pick_up_store_pick_up',
        'local_pick_up_return_ship',
        'local_pick_up_recycle',
      ],
    },
    {
      displayName: 'Mail To Us',
      name: 'mailToUs',
      productsList: [
        'digitize_emails_to_us_return_shipping',
        'mail_to_us_store_pick_up',
        'mail_to_us_recycle',
      ],
    },
    {
      displayName: 'Store Drop Off',
      name: 'storeDropOff',
      productsList: [
        'store_drop_of',
        'store_drop_off_local_drop_off',
        'store_drop_off_return_ship',
        'store_drop_off_recycle',
      ],
    },
  ],
  ENHANCE: [
    {
      displayName: 'Upload + Digital Download',
      name: 'digitalDonwload',
      productsList: [
        'digital_download',
      ],
    },
    {
      displayName: 'Email to us + digital download',
      name: 'emailDelivery',
      productsList: [
        'email_delivery',
      ],
    },
    {
      displayName: 'Scan Ship Kit',
      name: 'scanShipKit',
      productsList: ['easy_scan_ship_kit'],
    },
  ],
  CREATE: [
    {
      displayName: 'Return ship',
      name: 'returnShip',
      productsList: [
        'create_return_shipping',
      ],
    },
    {
      displayName: 'Local drop off',
      name: 'localDropOff',
      productsList: [
        'create_local_drop_off',
      ],
    },
    {
      displayName: 'Store pick up',
      name: 'storePickUp',
      productsList: [
        'create_store_pick_up',
      ],
    },
  ],
  ENHANCE_AND_CREATE: [
    {
      displayName: 'Upload',
      name: 'upload',
      productsList: [
        'return_shipping',
        'store_pick_up',
        'local_drop_off',
      ],
    },
    {
      displayName: 'Email to us',
      name: 'returnShip',
      productsList: [
        'mail_to_us_store_pick_up_local',
        'enhance_create_mail_to_us_store_pick_up',
        'enhance_create_mail_to_us_local_drop_off',
      ],
    },
    {
      displayName: 'Scan Ship kit',
      name: 'scanShipKit',
      productsList: ['enhance_create_scan_ship_kit'],
    },
  ],
};

export default TABS;
